module.exports = require("multer");


//////////////////
// WEBPACK FOOTER
// external "multer"
// module id = 15
// module chunks = 0